import { Toaster as Sonner } from "sonner";
import { cn } from "@/lib/utils";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className={cn("toaster")}
      toastOptions={{
        classNames: {
          toast:
            "group toast flex items-center border border-neutral-800 bg-background text-foreground shadow-lg",
          description: "text-muted-foreground text-sm",
          actionButton: "bg-primary text-primary-foreground",
          cancelButton: "bg-muted text-muted-foreground",
          error:
            "bg-destructive/15 border-destructive text-destructive [&>div>.toast-title]:text-destructive",
          success:
            "bg-green-500/15 border-green-500 text-green-500 [&>div>.toast-title]:text-green-500",
          warning:
            "bg-amber-500/15 border-amber-500 text-amber-500 [&>div>.toast-title]:text-amber-500",
          info: "bg-blue-500/15 border-blue-500 text-blue-500 [&>div>.toast-title]:text-blue-500",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
